(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request/{orgType}',
            params: {action: null},
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                globalValue: ['StaticLookUp', function(StaticLookUp) {
                    return StaticLookUp.getConfigSettingsPreLogin().$promise;
                }], 

                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
              
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        })
        .state('requestUnlock', {
            parent: 'account',
            url: '/reset/unlock/{orgType}',
            params: {action: null},
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                globalValue: ['StaticLookUp', function(StaticLookUp) {
                    return StaticLookUp.getConfigSettingsPreLogin().$promise;
                }], 
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
